import type { FC } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import TierHeaderMobile from '../../_partials/TierHeaderMobile';
import DefaultLayout from '../DefaultLayout';

export interface Props {
  tiers?: PapiDeviation[];
  tierId?: string;
}

const TierLayout: FC<Props> = ({ tiers, tierId }) => {
  const thisTier = (tiers || []).find(tier => `${tier.tier?.tierId}` === tierId);
  if (!(tierId && thisTier)) {
    return <DefaultLayout />;
  }

  return <TierHeaderMobile tier={thisTier} />;
};
TierLayout.displayName = 'TierLayout';

export default TierLayout;
